import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {
  ENABLED_FEATURES,
  ONBOARDING_GITHUB_IMPORT,
  ONBOARDING_GITHUB_SECURITY,
  SECURITY_LINK,
} from "@/util";
import { integrationsStore, onboardingApiStore } from "@/hooks";
import { GitHubAuthentication } from "@/components/integrations";
import {
  TextButton,
  Typography,
  FlexBox,
  Separator,
} from "@/components/common";
import CalloutSubStep from "./CalloutSubStep.vue";

/**
 * Opens the security practices link in a new tab.
 */

/**
 * Connects to GitHub to import code during onboarding.
 */
const __default__ = {
  name: "ConnectGitHubStep",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

function handleViewSecurityPractices() {
  window.open(SECURITY_LINK);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Typography), {
      el: "p",
      value: _unref(ONBOARDING_GITHUB_IMPORT)
    }, null, 8, ["value"]),
    _createVNode(_unref(GitHubAuthentication), { inactive: "" }),
    (_unref(ENABLED_FEATURES).ONBOARDING_PUBLIC_REPOS)
      ? (_openBlock(), _createBlock(_unref(FlexBox), {
          key: 0,
          align: "center",
          justify: "center",
          "full-width": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Separator), { style: {"width":"40px"} }),
            _createVNode(_unref(Typography), {
              secondary: "",
              el: "div",
              class: "q-ma-sm",
              value: "OR"
            }),
            _createVNode(_unref(Separator), { style: {"width":"40px"} })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(ENABLED_FEATURES).ONBOARDING_PUBLIC_REPOS)
      ? (_openBlock(), _createBlock(_unref(FlexBox), {
          key: 1,
          t: "4",
          justify: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TextButton), {
              outlined: "",
              icon: "changelog",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(onboardingApiStore).handleLoadNextStep('connect')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Upload Public Repo ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(CalloutSubStep, {
      icon: "security",
      message: _unref(ONBOARDING_GITHUB_SECURITY)
    }, {
      action: _withCtx(() => [
        _createVNode(_unref(TextButton), {
          text: "",
          color: "secondary",
          icon: "changelog",
          onClick: handleViewSecurityPractices
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Security Practices ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["message"]),
    (_unref(integrationsStore).validGitHubCredentials)
      ? (_openBlock(), _createBlock(_unref(FlexBox), {
          key: 2,
          t: "4",
          justify: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TextButton), {
              outlined: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(onboardingApiStore).handleLoadNextStep('connect')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Continue ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})